module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Assign to user","title_edit":"Edit user assignment","placeholder":"Search user by e-mail","warning":"There are many results, please constrain your search"},"da":{"title":"Tildel til bruger","title_edit":"Rediger brugertildeling","placeholder":"Søg efter brugere pr. e-mail","warning":"Der er mange resultater, begræns din søgning"}}')
  delete Component.options._Ctor
}
